import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import * as ProfileActions from 'src/app/stores/profile/profile.actions';
import { selectProfileData } from 'src/app/stores/profile/profile.selector';
import { LoadingState } from 'src/app/stores/store.states';

@Component({
  selector: 'app-main-layout-component',
  templateUrl: './main-layout-component.component.html',
  styleUrl: './main-layout-component.component.scss',
  standalone: false,
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private store = inject(Store);
  private auth = inject(AuthService);

  isLoggedIn = false;
  isJoiningRoute = false;
  profileLoaded = false;
  isTranslationLoaded = true; // translations already loaded via APP_INITIALIZER

  private destroy$ = new Subject<void>();

  constructor() {
    this.store.select(selectProfileData).subscribe((profile) => {
      this.profileLoaded = profile.loadingState === LoadingState.SUCCESS;
    });

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.isJoiningRoute = window.location.pathname.includes('/join');
        // Handle B2C special error redirects
        if (
          val.url.includes('AADB2C90118') ||
          val.url.includes('AADB2C90091')
        ) {
          this.router.navigate(['/']);
        }

        if (this.isLoggedIn && !this.profileLoaded && !this.isJoiningRoute) {
          this.store.dispatch(ProfileActions.loadingProfile());
        }
      }
    });
  }

  ngOnInit(): void {
    this.isLoggedIn = this.auth.isAuthenticated();

    // Kick off profile flow once after login
    if (this.isLoggedIn) {
      this.store.dispatch(ProfileActions.loginSuccess());
    }

    // react to token changes
    this.auth.oauth.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.isLoggedIn = this.auth.isAuthenticated();
    });
  }

  logout() {
    this.auth.logout();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
